function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "LANDING-DONACI\xD3N-SANGRE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Landing-donacion-sangre",
  transform: "translate(-624.000000, -3062.000000)"
}, React.createElement("g", {
  id: "w3share",
  transform: "translate(105.000000, 2705.000000)"
}, React.createElement("g", {
  id: "follow-icons-1",
  transform: "translate(303.000000, 357.000000)"
}, React.createElement("g", {
  id: "youtube_icon",
  transform: "translate(216.000000, 0.000000)"
}, React.createElement("circle", {
  id: "circle",
  stroke: "#FFFFFF",
  cx: 19,
  cy: 19,
  r: 18.5
}), React.createElement("path", {
  d: "M18.4988472,11.8751553 C18.5189769,11.8752071 18.5422378,11.8752762 18.5684807,11.8753682 L18.8811542,11.8769733 C20.3788958,11.88684 24.9814477,11.9460397 26.2933749,12.3012383 C27.1619267,12.5358066 27.8459894,13.2270059 28.0781626,14.1046426 C28.4578163,15.5363334 28.4957816,18.367883 28.4995782,18.919876 L28.4995782,19.1089209 C28.4957816,19.6609139 28.4578163,22.4924635 28.0781626,23.9241543 C27.8459894,24.801791 27.1619267,25.4641934 26.2933749,25.6987617 C25.6186537,25.8814353 24.0736093,25.9858202 22.5281615,26.0454687 L22.0141906,26.0637406 C20.5646594,26.1110774 19.2009846,26.1218358 18.6560049,26.1242809 L18.1564951,26.1242809 C17.5474001,26.1215481 15.9156445,26.108431 14.2843385,26.0454687 L13.7703975,26.0238829 C12.4062922,25.961657 11.1188773,25.8611382 10.5191251,25.6987617 C9.65057328,25.4641934 8.96651062,24.801791 8.73433741,23.9241543 C8.35468374,22.4924635 8.31671837,19.6609139 8.31292184,19.1089209 L8.31292184,18.919876 C8.31671837,18.367883 8.35468374,15.5363334 8.73433741,14.1046426 C8.96651062,13.2270059 9.65057328,12.5358438 10.5191251,12.3012383 C11.8310831,11.9460397 16.4336145,11.88684 17.9313484,11.8769733 L18.2440202,11.8753682 C18.270263,11.8752762 18.2935237,11.8752071 18.3136533,11.8751553 Z M16.341605,16.0010059 L16.341605,22.027791 L21.6178624,19.0144727 L16.341605,16.0010059 Z",
  id: "youtube_form",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 38"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/youtube.5fc31ac4.svg";
export { SvgComponent as ReactComponent };